import React, { useEffect, useState } from 'react';
import './index.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import { CgArrowLongLeft } from 'react-icons/cg';
import { IoMailOpenOutline } from 'react-icons/io5';
import { useAuth } from '../../../context/AuthContext';
import RegistrationForm from '../../../components/forms/registration';
import { ProgressBar } from 'react-bootstrap';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

function BusinessProfile() {

  const auth = getAuth();
  const { user, businessProfile } = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [regData, setRegData] = useState({
    createdOn: new Date(),
    updatedOn: new Date(),
    ownerID: user && user.uid,
    companyLogo: null,
    businessName: '',
    address: '',
    pincode: '',
    city: '',
    state: '',
    cin: '',
    pan: '',
    gst: '',
    rera: '',
    phoneNumber: '',
    alternateNumber: '',
    email: '',
    website: '',
    signature: null,
    status: '',
    subscriptionID: null
  });

  useEffect(() => {
    if (businessProfile && businessProfile) {
      setRegData({
        ...regData,
        createdOn: businessProfile.createdOn,
        businessName: businessProfile.businessName,
        ownerID: user && user.uid,
        state: businessProfile.state,
        phoneNumber: businessProfile.phoneNumber,
        status: businessProfile.status,
        email: user && user.email
      });
    }
  }, [])


  async function handleSetGeneralSettings(bid) {
    await setDoc(doc(db, "Businesses", bid, "Settings", "general"), {
      numberOfInstallment: '12',
      paymentTerms: '30',
      taxRate: '5',
      overdueInterest: '0',
      overdueTaxRate: '18',
      propertyType: 'Building',
      termsConditions: '',
      updatedOn: new Date()
    });
  }

  async function handleSetReminderSettings(bid) {
    await setDoc(doc(db, "Businesses", bid, "Settings", "reminders"), {
      booking: true,
      payment: true,
      dueDate: true,
      newUpdates: true,
      updatedOn: new Date()
    });
  }

  async function handleSetUsers(uid, name, email, bid, role) {
    await setDoc(doc(db, "Users", uid), {
      name: name,
      email: email,
      businessID: bid,
      role: role,
      lastLogout: null,
      lastLogin: new Date(),
      createdAt: new Date()
    });
  }

  function handleUpdateCustomClaim() {
    const { accessToken, displayName, email, uid, claims } = user;
    const { bid, role } = claims;

    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_FIREBASE_FUNCTIONS}/update-claims`,
      headers: {
        "idToken": accessToken,
        "uid": uid
      },
      data: {
        bid,
        businessProfile: true,
        role
      }
    };

    axios.request(config)
      .then((response) => {
        const token = response.data.customToken;
        signInWithCustomToken(auth, token);
        handleSetUsers(uid, displayName, email, bid, role);
        handleSetGeneralSettings(bid);
        handleSetReminderSettings(bid);
        setIsCompleted(true);
      }).catch((error) => {
        toast.error(error.response.data.message);
      });
  }

  async function handleRegistrationData() {
    setIsLoading(true);
    try {
      await setDoc(doc(db, "Businesses", businessProfile.id), regData);
      handleUpdateCustomClaim();
    } catch (error) {
      console.log('Updating Business Profile [Error] : ', error);
      setIsLoading(false);
    }
  }

  if (user && !user.emailVerified) {
    return (
      <section className='registration-wrapper'>
        <div className='container'>
          <div className='row h-100vh align-items-center justify-content-around'>
            <div className='col-md-6 col-lg-6 py-5 my-5'>
              <div className='bg-white border mb-0 card custom-shadow'>
                <div className='card-head p-3 text-center'>
                  <div className="card-head-img">
                    <IoMailOpenOutline size={28} color={`var(--bs-primary)`} />
                  </div>
                  <h3 className="text-center mt-3">Check Your Email</h3>
                  <p className='text-secondary'>Verification Email has been Sent to <br /><span className='text-decoration-underline text-primary'>{user && user.email && user.email}</span></p>
                  <p className='text-muted'>Please check your email & click the link to verify your email.</p>
                </div>
                <div className='d-flex align-items-center justify-content-center'>
                  <div className='col-md-6 col-12'>
                    <ProgressBar
                      animated now={100}
                      style={{ height: 10 }}
                    />
                    <p className='mt-3 mb-0 text-secondary text-center'>
                      <small>Waiting for your response</small>
                    </p>
                  </div>
                </div>
                <hr />
                <div className='p-md-4 pt-md-2 m-md-1 p-3 pb-5'>
                  <div className='d-flex justify-content-center align-items-center'>
                    <div className='back-to-login'>
                      <a href="/login" className='text-uppercase'>
                        <CgArrowLongLeft size={26} />
                        <span>Back to</span>
                        <span className='fw-600 ms-1'>Login</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  } else {
    return (
      <section className='registration-wrapper'>
        <div className='container'>
          <div className='reg-head'>
            {/* Registration Head */}
          </div>
          {
            user && user.emailVerified ?
              <div className='row'>
                <div className='col-10 offset-1'>
                  <div className='reg-body rounded shadow'>
                    <RegistrationForm
                      isCompleted={isCompleted}
                      isLoading={isLoading}
                      regData={regData}
                      setRegData={setRegData}
                      handleRegistrationData={handleRegistrationData}
                    />
                  </div>
                </div>
              </div>
              :
              null
          }
        </div>
      </section>
    );
  }
}

export default BusinessProfile;
